import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CourseCard.css';

const CourseCard = ({ course }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/courses/${course.id}`);
  };

  return (
    <article
      className="cf-course-card"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      {course.imageUrl && (
        <div className="cf-course-image-wrap">
          <img src={course.imageUrl} alt={course.name} className="cf-course-image" />
        </div>
      )}
      <div className="cf-course-header">
        <h3 className="cf-course-name">{course.name}</h3>
        <span className="cf-course-category">{course.category}</span>
      </div>
      <p className="cf-course-description">{course.description}</p>
      <div className="cf-course-meta">
        <span className="cf-course-level">{course.level}</span>
        <span className="cf-course-duration">{course.duration}</span>
      </div>
    </article>
  );
};

export default CourseCard;


